$(document).ready(function(){
    $('.cstm-sho-header-menuandicon-icon').click(function (e) {
        e.preventDefault();
        e.stopPropagation(); 
        $(this).toggleClass('cstm-close-icon-set')
        $('.cstm-sho-header-menuandicon-menu').fadeToggle();
    });
    $('.cstm-sho-header-menuandicon-menu').on('click', function (e) {
        e.stopPropagation();
    });
    $(document).on('click', function () {
        $('.cstm-sho-header-menuandicon-menu').fadeOut();
        $('.cstm-sho-header-menuandicon-icon').removeClass('cstm-close-icon-set')
    });

    // 
    $('.cstm-sho-review-slider-block_item-main').slick({
        dots: false,
        infinite: true,
        slidesToShow: 3,
        autoplay: true,
        slidesToScroll: 1,
         responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480, 
        settings: {
          slidesToShow: 1,
        }
      }
    ],
        prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0963/3523/3334/files/arrows-left.svg?v=1767936710" alt="Previous"></button>',
        nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0963/3523/3334/files/arrows-right.svg?v=1767936778" alt="Next"></button>'
    });

    // collection page slider
    // $('.cstm-product-slider').slick({
    //     dots: false,
    //     infinite: true,
    //     slidesToShow: 2,
    //     autoplay: false,
    //     slidesToScroll: 1,
    // });

});

/*-----------------accordion-------------------------*/

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.faq-question').forEach(button => {
    button.addEventListener('click', () => {
      const item = button.closest('.faq-item');
      const icon = button.querySelector('.faq-icon');
      const isOpen = item.classList.contains('active');

      document.querySelectorAll('.faq-item').forEach(i => {
        i.classList.remove('active');
        const img = i.querySelector('.faq-icon');
        if (img) img.src = img.dataset.plus;
      });

      if (!isOpen) {
        item.classList.add('active');
        icon.src = icon.dataset.minus;
      }
    });
  });
});





function initReviewSlider() {
  if ($(window).width() < 1025) {
    if (!$('.category-nav').hasClass('slick-initialized')) {
      $('.category-nav').slick({
        dots: false,
        infinite: true,
        autoplay: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false
      });
    }
  } else {
    if ($('.category-nav').hasClass('slick-initialized')) {
      $('.category-nav').slick('unslick');
    }
  }
}

$(document).ready(function () {
  initReviewSlider();
});

$(window).on('resize', function () {
  initReviewSlider();
});


jQuery(document).ready(function($){
  $('.cs-slider-row').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: true,
    prevArrow: '<button class="custom-prev">←</button>',
    nextArrow: '<button class="custom-next">→</button>',
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});
